export default "__VITE_ASSET__D4r8gJG6__"